import React from 'react';

const Analytics = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 510 510"
            {...props}>
            <g>
                <g>
                    <path
                        d="M477.083,440.502c19.253,0,34.917-15.664,34.917-34.918V50c0-27.57-22.43-50-50-50H50C22.43,0,0,22.43,0,50v355.584
			c0,19.254,15.664,34.918,34.917,34.918H46V492H10c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h492c5.523,0,10-4.478,10-10
			c0-5.522-4.477-10-10-10h-36v-51.498H477.083z M20,50c0-16.542,13.458-30,30-30h412c16.542,0,30,13.458,30,30v22H21.004
			c-0.339,0-0.674,0.018-1.004,0.051V50z M110,492H66v-90h44V492z M222,492h-44V291.432h44V492z M334,492h-44V376h44V492z
			 M456,256.5h-64c-5.523,0-10,4.478-10,10v50.499c0,5.522,4.477,10,10,10s10-4.478,10-10V276.5h44V492h-44V384.25
			c0-5.522-4.477-10-10-10s-10,4.478-10,10V492h-28V366c0-5.522-4.477-10-10-10h-64c-5.523,0-10,4.478-10,10v126h-28V281.432
			c0-5.522-4.477-10-10-10h-64c-5.523,0-10,4.478-10,10V492h-28V392c0-5.522-4.477-10-10-10H56c-5.523,0-10,4.478-10,10v28.502
			H34.917c-8.226,0-14.917-6.692-14.917-14.918V91.949C20.33,91.982,20.665,92,21.004,92H492v313.584
			c0,8.226-6.692,14.918-14.917,14.918H466V266.5C466,260.978,461.523,256.5,456,256.5z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M448,36H222.065c-5.523,0-10,4.478-10,10s4.477,10,10,10H448c5.523,0,10-4.478,10-10S453.523,36,448,36z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M111.07,38.93C109.21,37.07,106.63,36,104,36s-5.21,1.069-7.07,2.93C95.07,40.79,94,43.37,94,46s1.07,5.21,2.93,7.069
			C98.79,54.93,101.37,56,104,56s5.21-1.07,7.07-2.931C112.93,51.21,114,48.63,114,46S112.93,40.79,111.07,38.93z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M71.07,38.93C69.21,37.07,66.63,36,64,36s-5.21,1.069-7.07,2.93C55.07,40.79,54,43.37,54,46s1.07,5.21,2.93,7.069
			C58.79,54.93,61.37,56,64,56s5.21-1.07,7.07-2.931C72.93,51.21,74,48.63,74,46S72.93,40.79,71.07,38.93z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M151.07,38.93C149.21,37.07,146.64,36,144,36c-2.63,0-5.21,1.069-7.07,2.93C135.07,40.79,134,43.37,134,46
			s1.07,5.21,2.93,7.069C138.79,54.93,141.37,56,144,56s5.21-1.07,7.07-2.931C152.93,51.21,154,48.63,154,46
			S152.93,40.79,151.07,38.93z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M399.07,345.57c-1.86-1.87-4.44-2.93-7.07-2.93s-5.21,1.061-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
			s1.07,5.21,2.93,7.07c1.86,1.859,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93s2.93-4.44,2.93-7.07
			C402,350,400.93,347.43,399.07,345.57z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M424,135.939c-19.851,0-36,16.149-36,36c0,7.885,2.555,15.181,6.871,21.118l-66.425,66.425
			c-5.155-2.853-11.077-4.483-17.375-4.483c-5.675,0-11.045,1.325-15.824,3.674l-69.359-69.359
			c2.853-5.155,4.483-11.077,4.483-17.375c0-19.851-16.149-36-36-36s-36,16.149-36,36c0,6.938,1.978,13.42,5.392,18.922
			l-59.053,59.052c-5.155-2.853-11.077-4.483-17.374-4.483c-19.851,0-36,16.149-36,36s16.149,36,36,36c19.851,0,36-16.149,36-36
			c0-6.298-1.63-12.22-4.483-17.375l59.758-59.758c4.763,2.329,10.111,3.641,15.76,3.641c6.297,0,12.219-1.63,17.374-4.483
			l68.68,68.679c-3.391,5.49-5.354,11.95-5.354,18.863c0,19.851,16.149,36,36,36s36-16.149,36-36c0-6.298-1.63-12.22-4.483-17.375
			l68.205-68.205c4.093,1.622,8.546,2.522,13.207,2.522c19.851,0,36-16.149,36-36C460,152.088,443.851,135.939,424,135.939z
			 M87.337,297.432c-8.822,0-16-7.178-16-16c0-8.822,7.178-16,16-16c8.822,0,16,7.178,16,16
			C103.337,290.254,96.159,297.432,87.337,297.432z M194.372,187.939c-8.822,0-16-7.178-16-16c0-8.822,7.178-16,16-16
			s16,7.178,16,16C210.372,180.761,203.194,187.939,194.372,187.939z M311.072,306.999c-8.822,0-16-7.178-16-16
			c0-8.822,7.178-16,16-16c8.822,0,16,7.178,16,16C327.072,299.821,319.894,306.999,311.072,306.999z M424,187.939
			c-8.822,0-16-7.178-16-16c0-8.822,7.178-16,16-16c8.822,0,16,7.178,16,16C440,180.761,432.822,187.939,424,187.939z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M148.33,128.951c-1.87-1.86-4.44-2.931-7.07-2.931c-2.64,0-5.22,1.07-7.08,2.931c-1.86,1.859-2.92,4.439-2.92,7.069
			s1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.08,2.93c2.63,0,5.2-1.069,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07
			S150.19,130.81,148.33,128.951z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M104,126.021H56c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h48c5.523,0,10-4.478,10-10
			C114,130.499,109.523,126.021,104,126.021z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M104,174.021H56c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h48c5.523,0,10-4.478,10-10
			C114,178.499,109.523,174.021,104,174.021z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Analytics;
